<template lang='pug'>
  .image-box(ref="box")
    img(v-if="src" :src="src" :alt="mediaObject.alt_text || ''")
</template>

<script>
  export default {
    name: 'ImgBox',
    props: {
      default: () => {},
      mediaId: [String, Number],
      mediaObj: Object
    },

    data: function() {
      return {
        width: 0,
        height: 0,
        interval: null
      };
    },

    computed: {
      mediaObject() {
        return this.asyncMediaObj || this.mediaObj
      },

      aspect() {
        var aspect = {};
        if (!this.width || !this.height || !this.mediaObject || !this.mediaObject.url) {
          return aspect;
        }
        aspect.url = this.mediaObject.url;
        aspect.crop = `&w=${this.width}&h=${this.height}&${this.getWatermarkParams(this.mediaObject.watermark)}`;
        var targetRatio = this.width / this.height;
        var temp = targetRatio;
        this.mediaObject.aspects.forEach(mediaAspect => {
          var ratioDifference = Math.abs(mediaAspect.m - targetRatio);
          if (ratioDifference <= temp) {
            temp = ratioDifference;
            aspect.url = mediaAspect.url || this.mediaObject.url;
            aspect.crop = `${mediaAspect.cropQuery}&w=${this.width}&h=${this.height}`;
            var watermarkParams = this.getWatermarkParams(this.mediaObject.watermark, mediaAspect);
            if (watermarkParams) {
              aspect.crop += `&${watermarkParams}`;
            }
            aspect.mediaAspect = mediaAspect;
          }
        });
        return aspect;
      },

      src() {
        if (!this.aspect || !this.aspect.url) {
          return '';
        }
        return `${this.remapUrl(this.aspect.url)}?${this.aspect.crop}&dpr=1.7&q=50&auto=format`;
      }
    },

    asyncComputed: {
      asyncMediaObj() {
        if (this.mediaId) {
          return this.$http.get('/api/media/getMediaObject', {
            params: {
              id: this.mediaId
            }
          }).then(res => res.data);
        } else {
          return Promise.resolve(null).then(res => res);
        }
      }
    },

    methods: {
      getWidthAndHeight() {
        var clientWidth = this.$el.clientWidth;
        var clientHeight = this.$el.clientHeight;
        this.width = clientWidth;
        this.height = clientHeight + 1;
      },

      remapUrl(url) {
        if (!url) {
          return url;
        }
        var imgixHostMap = {
          'd3ewrnwdcmri66.cloudfront.net': 'mr-cdn.imgix.net',
          'ddxs94deh28np.cloudfront.net': 'mr-cdn-staging.imgix.net'
        };
        var hostRE = /https?:\/\/([^\/]+)\/.*$/;
        var awsHost = url.replace(hostRE, '$1');
        var imgxHost = imgixHostMap[awsHost];
        if (imgxHost) {
          return url.replace(awsHost, imgxHost);
        }
        return url;
      },

      getWatermarkParams(watermarkObj, mediaAspect) {
        if (!watermarkObj || !watermarkObj.url) {
          return '';
        }
        mediaAspect = mediaAspect || {};
        var markparams = [];
        var markalign = mediaAspect.markalign || watermarkObj.markalign;
        var markpad = mediaAspect.markpad || watermarkObj.markpad;
        var markw = mediaAspect.markw || watermarkObj.markw;
        var markh = mediaAspect.markh || watermarkObj.markh;
        markparams.push('mark=' + watermarkObj.url);
        markparams.push('&markalign=' + markalign);
        markparams.push('&markpad=' + markpad);
        markparams.push('&markfit=clip&markw=' + markw + '&markh=' + markh);
        return markparams.join('');
      }
    },

    mounted() {
      var self = this;
      self.getWidthAndHeight();
      self.interval = window.setInterval(function() {
        self.getWidthAndHeight();
      }, 300);
    },

    beforeDestroy() {
      clearInterval(this.interval);
    }
  }
</script>

<style lang='stylus'>
  .image-box
    width 100%
    height 100%
    overflow hidden
    
    img
      width 100%
      vertical-align middle
      font-size 0px
      
</style>
